import React from 'react';
import { safeHTML } from '../../../utils/safeHTML';
import Picture from '../../baseComponents/gui/picture/Picture';
import classNames from 'classnames';
import { useTranslation } from '../../../translations';
import { useLanguageControls } from '../../../hooks/useLanguageControls';
const SlideModalItem = React.forwardRef(function SlideModalItem({ index, img, title, text }, ref) {
  const { t } = useTranslation();
  const { getLocalizedText } = useLanguageControls();
  return (
    <div
      className={classNames(`slide-modal__item slide-modal__item_${index}`, {
        'slide-modal__item_image': img,
      })}
      ref={ref}
    >
      {img && (
        <div className={'slide-modal__item-image'}>
          {typeof img === 'string' ? <img src={img} alt={'slide-image'} /> : <Picture {...img} />}
        </div>
      )}
      <div className={'slide-modal__item-content'}>
        <h2 className={'slide-modal__item-title'}>{safeHTML(t(title))}</h2>
        {text && (
          <div className={'slide-modal__item-text'}>
            {text?.map?.((text, i) => {
              const translationObj = t(text, { returnObjects: true });
              const localizedText = getLocalizedText(translationObj);
              return <React.Fragment key={i}>{safeHTML(localizedText)}</React.Fragment>;
            })}
          </div>
        )}
      </div>
    </div>
  );
});
export default SlideModalItem;
SlideModalItem.propTypes = {};
